import { useEffect, useRef } from 'react'
import { SDrawerOrModal, SGeneralForms } from 'shj-components'
import { Button, Col, Form, Input, InputNumber, message, Row, Select, Space, Spin } from 'antd'
import { useSetState } from 'ahooks'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import {
  addOrUpdatePaymentApply,
  findReceiptApplyForJdPayResponseListByRequest,
  submitForPreViewList,
} from '@/services/fmsServices'
import styles from './index.module.less'
interface IProps {
  title: string
  orderId: string
  open: boolean
  detailsInfo: Record<string, any>
  setOpen: (open: boolean) => void
  reload?: () => void
  preview?: boolean
  dataInfo?: any // 回显数据
}
export default function AddJdPaymentAplly(prpos: IProps) {
  const [form] = Form.useForm()
  const { open, title, setOpen, orderId, detailsInfo, reload, dataInfo } = prpos
  const [state, setState] = useSetState<any>({
    loading: false,
    btnLoading: false,
    list: [],
    maxFee: [],
    jdPin: '',
    totalFee: 0,
    confirmOpen: false,
    responseData: {},
    confirmLoading: false,
  })

  useEffect(() => {
    open && getOptions()
  }, [open, dataInfo])

  const onsubmit = () => {
    form.validateFields().then(values => {
      const newSet = new Set()
      let isRepeat = values.receiptApplyResquestList.some(item => {
        if (newSet.has(item.receiptApplyId)) {
          return true // 重复
        }
        newSet.add(item.receiptApplyId)
        return false
      })
      if (isRepeat) {
        message.error('应收单重复！')
        return
      }
      values.receiptApplyResquestList.forEach((item, index) => {
        let originObj = state.list.find((i: any) => i.id === item.receiptApplyId)
        // 填补单号
        item.receiptApplyBillNo = originObj?.billNo
      })
      console.log(values.receiptApplyResquestList)
      let submitObj = {
        orderAccoutId: detailsInfo?.orderAccountId,
        receiptApplyResquestList: values.receiptApplyResquestList,
        showFinAccountInfoFlag: true,
        showVerifyConfigFlag: true,
        showTransactionTypeNameFlag: true,
      }
      submitForPreViewList(submitObj).then(res => {
        setState({ responseData: res, confirmOpen: true })
      })
    })
  }
  const onCancel = () => {
    form?.resetFields()
    setState({
      totalFee: 0,
      maxFee: [],
    })
    setOpen(false)
  }
  const onConfirmCancel = () => {
    setState({ confirmOpen: false })
  }
  const getOptions = async () => {
    setState({ loading: true })
    try {
      let resData: any = await findReceiptApplyForJdPayResponseListByRequest({
        orderAccountId: detailsInfo?.orderAccountId,
      })
      resData = resData.map((item: any) => {
        return {
          ...item,
          label: item.receiptTypeName + ' ' + item.billNo,
          value: item.id,
        }
      })
      if (dataInfo && dataInfo.transDetailList) {
        // 编辑
        console.log(dataInfo)
        let newArray: any = []
        let totalFee = 0
        let maxFee: number[] = []
        dataInfo?.transDetailList?.forEach((item: any) => {
          newArray = [...newArray, ...item.receiptApplyDetailList]
        })
        newArray = newArray.map((item: any, index: number) => {
          totalFee += item.needVerifiedAmount
          let unverifiedAmount: number = resData.find(
            el => el.id === item.receiptApplyId
          )?.unverifiedAmount
          maxFee[index] = unverifiedAmount
          return {
            ...item,
            amount: item.needVerifiedAmount,
          }
        })
        form.setFieldsValue({
          receiptApplyResquestList: newArray,
        })
        setState({
          totalFee,
          maxFee: [...maxFee],
        })
      }else{
        // 新增 默认一条
        form.setFieldsValue({
          receiptApplyResquestList: [{
            receiptApplyId: undefined,
            amount: undefined,
          }],
        })
      }
      setState({ list: resData, loading: false })
      return Promise.resolve({ list: resData })
    } catch (err) {
      setState({ loading: false })
    }
  }
  const renderNode = key => {
    let optioId = form.getFieldsValue().receiptApplyResquestList[key]?.receiptApplyId
    let newMaxFee: any = [...state.maxFee]
    let unverifiedAmount
    if (optioId) {
      unverifiedAmount = state.list.find(item => item.id === optioId)?.unverifiedAmount
      newMaxFee[key] = unverifiedAmount
      setState({
        maxFee: [...newMaxFee],
      })
    }
  }
  const onValuesChange = (changedValues, allValues) => {
    console.log(changedValues, allValues)
    let List = allValues.receiptApplyResquestList
    let totalFee = 0
    List.forEach(item => {
      if (item?.amount) {
        totalFee += item.amount
      }
    })
    setState({ totalFee })
  }
  const onConfirmSubmit = () => {
    let submitData = state.responseData
    setState({ confirmLoading: true })
    addOrUpdatePaymentApply({
      id: dataInfo?.id || null,
      orderAccountId: detailsInfo?.orderAccountId,
      transList: submitData.transResponseList.map((item: any) => {
        item.receiptApplyRequestList = item.receiptApplyResponseList
        return item
      }),
      companyOrgId: submitData.companyOrgId,
      finAccountId: submitData.finAccountId,
    })
      .then(res => {
        message.success('提交成功！')
        onConfirmCancel()
        onCancel()
        reload && reload()
      })
      .finally(() => {
        setState({ confirmLoading: false })
      })
  }
  return (
    <SDrawerOrModal
      title={title}
      mode="drawer"
      open={open}
      width={500}
      onCancel={onCancel}
      antdProps={{
        footer: (
          <div className={styles.footer}>
            <p>合计收款：{state.totalFee}元</p>
            <div>
              <Button onClick={onCancel}>取消</Button>
              {/* disabled={state.errInfo.length} */}
              <Button
                style={{ marginLeft: 15 }}
                loading={state.btnLoading}
                type="primary"
                onClick={onsubmit}
              >
                提交
              </Button>
            </div>
          </div>
        ),
        maskClosable: false,
      }}
    >
      {open && (
        <div>
          <Spin spinning={state.loading}>
            <Form
              form={form}
              name="dynamic_form_nest_item"
              style={{ maxWidth: 600 }}
              autoComplete="off"
              onValuesChange={onValuesChange}
            >
              <Form.List name="receiptApplyResquestList">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <>
                        <Space key={key} style={{ display: 'flex' }} align="baseline">
                          <Form.Item
                            {...restField}
                            name={[name, 'receiptApplyId']}
                            rules={[{ required: true, message: '请选择' }]}
                          >
                            <Select
                              style={{ width: '260px' }}
                              placeholder="请选择"
                              allowClear
                              onChange={() => {
                                renderNode(name)
                              }}
                            >
                              {state.list.map(item => (
                                <Select.Option value={item.id}>{item.label}</Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, 'amount']}
                            rules={[{ required: true, message: '请输入' }]}
                          >
                            <InputNumber
                              max={state.maxFee[name]}
                              style={{ width: '180px' }}
                              suffix="元"
                              placeholder="金额"
                            />
                          </Form.Item>
                          <MinusCircleOutlined
                            onClick={() => {
                              remove(name)
                              let newMaxFee: any = [...state.maxFee]
                              newMaxFee[name] = null
                              setState({
                                maxFee: [...newMaxFee],
                              })
                            }}
                          />
                        </Space>
                        {state.maxFee[name] && (
                          <p
                            style={{
                              marginTop: '-20px',
                              marginBottom: '15px',
                              color: 'gray',
                              fontSize: '14px',
                            }}
                          >
                            最大可收款{state.maxFee[name]}元
                          </p>
                        )}
                      </>
                    ))}
                    <Form.Item>
                      <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                        添加收款
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form>
          </Spin>

          <SDrawerOrModal
            title={'请确认收款信息'}
            mode="modal"
            open={state.confirmOpen}
            width={500}
            onCancel={onConfirmCancel}
            antdProps={{
              footer: (
                <div>
                  <div>
                    <Button onClick={onConfirmCancel}>取消</Button>
                    <Button
                      style={{ marginLeft: 15 }}
                      loading={state.confirmLoading}
                      type="primary"
                      onClick={onConfirmSubmit}
                    >
                      确认发起收款
                    </Button>
                  </div>
                </div>
              ),
              maskClosable: false,
            }}
          >
            <Row className={styles.confirmRow}>
              <Col span={12}>收款类型</Col>
              <Col span={12}>应收金额</Col>
            </Row>
            {state.responseData?.transResponseList?.map((item: any) => {
              return (
                <Row className={styles.confirmRow}>
                  <Col span={12}>{item.transactionTypeName}</Col>
                  <Col span={12}>{item.amount}</Col>
                </Row>
              )
            })}
          </SDrawerOrModal>
        </div>
      )}
    </SDrawerOrModal>
  )
}
